// extracted by mini-css-extract-plugin
export default {"studioTypeContainer":"DropDownElement_studioTypeContainer__r96Z1"};